<template>
  <!-- <jspang></jspang> -->
  <div class="leftNav">
    <el-menu
      :default-active="activerouter"
      class="el-menu-vertical-demo"
      @select="handleSelect"
      @open="handleOpen"
      @close="handleClose"
      background-color="#108EE9"
      text-color="#fff"
      active-text-color="#fff"
      router
      style="position: fixed;width:200px;min-height:860px;"
    >
      <div class="head" @click="hrefSz">
        <img :src="$store.state.shopInformation.shopLogo" class="headImg" alt />
        <div class="headTitle">
          <div>{{title}}</div>
          <div
            style="margin-top:0px;  overflow: hidden; 
  white-space: nowrap;
  text-overflow: ellipsis;width:100px;"
          >{{$store.state.shopInformation.shopName}}</div>
        </div>
      </div>

      <el-menu-item ref="items" index="/home" class="textCenter">
        <img src="../../assets/icon/sygk.png" alt />
        <span slot="title">首页概况</span>
      </el-menu-item>

      <el-menu-item ref="items" index="/orderManagment" class="textCenter">
        <img src="../../assets/icon/ddgl.png" alt />
        <span slot="title">订单管理</span>
      </el-menu-item>

      <el-menu-item ref="items" index="/commodity" class="textCenter">
        <img src="../../assets/icon/spgl.png" alt />
        <span slot="title">商品管理</span>
      </el-menu-item>

      <el-menu-item ref="items" index="/information" class="textCenter">
        <img src="../../assets/icon/sjtj.png" alt />
        <span slot="title">数据统计</span>
      </el-menu-item>

      <el-menu-item ref="items" index="/customer" class="textCenter">
        <img src="../../assets/icon/khgl.png" alt />
        <span slot="title">会员管理</span>
      </el-menu-item>

      <el-menu-item ref="items" index="/couponList" class="textCenter">
        <img src="../../assets/icon/coupon.png" style="width:18px;height:18px" alt />
        <span slot="title">优惠券管理</span>
      </el-menu-item>

      <el-menu-item ref="items" index="/bill" class="textCenter">
        <img src="../../assets/icon/zdmx.png" alt />
        <span slot="title">账单明细</span>
      </el-menu-item>

      <el-menu-item ref="items" index="/set" class="textCenter">
        <img src="../../assets/icon/szgl.png" alt />
        <span slot="title">设置管理</span>
      </el-menu-item>
      <el-menu-item ref="items" index="/charge" class="textCenter">
        <img src="../../assets/icon/ccs.png" alt />
        <span slot="title">充值活动</span>
      </el-menu-item>
      <el-menu-item ref="items" index="/invoicingFather/invoicing" class="textCenter">
        <img src="../../assets/icon/jxcgl.png" style="margin-left:15px" alt />
        <span slot="title">进销存管理</span>
      </el-menu-item>
      <el-menu-item ref="items" index="/cashierOrderAD" class="textCenter">
        <img src="../../assets/icon/sykd.png"  alt />
        <span slot="title">收银开单</span>
      </el-menu-item>
      <el-menu-item ref="items" index="/ZWHXJL" class="textCenter">
        <img src="../../assets/icon/hxjl.png"  alt />
        <span slot="title">核销记录</span>
      </el-menu-item>
       <el-menu-item ref="items" index="/gasManage" class="textCenter">
       <img src="../../assets/icon/gas-icon.png"  alt />
        <span slot="title">油站管理</span>
      </el-menu-item>
      <el-menu-item ref="items" index="/returnsAndRefunds" class="textCenter">
        <img src="../../assets/icon/thtk.png"  alt />
        <span slot="title">退货退款</span>
      </el-menu-item>
     
      <!-- <el-menu-item ref="items" style="margin-left:-15px" @click="jumpTT('customer','2')" class="textCenter">
        <img src="../../assets/icon/ccs.png" alt />
        <span slot="title">充值送</span>
      </el-menu-item>-->

      <div class="portrait">
        <el-popover placement="top" title width="180" trigger="click" content>
          <div class="exit2">
            <div>{{workerInfo.nickName}}</div>
            <div>{{workerInfo.phoneNum}}</div>
          </div>
          <div class="br"></div>
          <div class="exit" @click="accountSettings" style="cursor:pointer">设置账号</div>
          <div class="br"></div>
          <div class="exit" @click="hrefSz">{{$store.state.shopInformation.shopName}}</div>
          <div class="br"></div>
          <div class="exit" @click="dialogVisible = true">
            退出
            <img style="float:right" src="../../assets/icon/tc.png" alt />
          </div>
          <el-button
            style="background:#28a0f7;border:none;box-shadow: none;height:100%;padding:0;width:200px"
            slot="reference"
            class="center"
          >
            <div style=" display: flex;justify-content: center;align-items: center;width: 150px;">
              <img :src="workerInfo.headLogo" alt />
              <div class="phone">{{workerInfo.nickName}}</div>
            </div>
          </el-button>
        </el-popover>
      </div>
    </el-menu>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确定退出用户吗</span>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="exit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>
<script>
export default {
  name: "leftNav",
  data() {
    return {
      title: "钱如潮收银系统",
      title2: "张小小店铺",
      portrait: require("../../assets/icon/orange.png"),
      phone: "17828364726",
      dialogVisible: false,
      userList: "", //用户信息
      workerInfo: "",
      activerouter: ""
    };
  },
  watch: {
    $route(to, from) {
      this.activerouter = to.path;
      // console.log(to.path,'路由变化！！！！！！！！！！！！！！！！！');
    }
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.Shop_workerInfo();
    this.Shop_shopInfo(); //店铺信息
  },
  mounted() {
    this.activerouter = window.location.hash;
    this.activerouter = this.activerouter.substr(1);
  },
  methods: {
    //获取店铺信息
    Shop_shopInfo() {
      var that = this;
      that.request
        .get("qrcapi/Shop_shopInfo", {
          userId: this.userList.id,
          sessionId: this.userList.sessionId
        })
        .then(function(res) {
          // that.setCookie("shopInformation", JSON.stringify(res.data));
          that.$store.commit('changeShopInformation',res.data);
        //   that.$store.state.shopInformation = res.data;
          if (res.code == 1) {
            // that.$router.push("/home");
          } else {
            that.$message.error("未创建店铺");
            that.$router.push("/creatStore");
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //个人信息
    Shop_workerInfo() {
      this.request
        .post("qrcapi/Shop_workerInfo", {
          userId: this.userList.id,
          sessionId: this.userList.sessionId
        })
        .then(res => {
          if (res.code == 1) {
            // this.$message({
            //   type: "success",
            //   message: res.msg
            // });

            this.workerInfo = res.data;
            this.setCookie("defaultRepositoryId", this.workerInfo.repositoryId);
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //跳转
    jumpTT(adress, message) {
      // this.$router.push(adress)
      this.$router.push({ path: adress, query: { docId: message } });
    },
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    handleSelect(key, keyPath) {
    },
    hrefSz() {
      this.$router.push("/ModifyStore");
    },
    exit() {
      var that = this;
      var userId = this.userList.id; //用户Id
      var sessionId = this.userList.sessionId;
      this.request
        .post("qrcapi/Login_loginOut", {
          userId: userId,
          sessionId: sessionId
        })
        .then(function(response) {
          if (response.code == 1) {
            // that.$message({
            //   type: "success",
            //   message: response.msg
            // });
            that.dialogVisible = false;
            that.$router.push("/");
            localStorage.removeItem("repositoryLists")
            localStorage.removeItem("confirmChooseList")
            localStorage.removeItem("chooseList")
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    accountSettings() {
      this.$router.push("/accountSettings");
    }
  }
};
</script>

<style scoped>
.leftNav .headImg {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  /* margin-left: 20px; */
}
.leftNav {
  color: white;
  font-size: 12px;
  /* position: fixed; */
  top: 0;
}
.head {
  display: flex;
  border-bottom: 1px solid rgb(72, 166, 234);
  padding: 20px 0;
  margin-top: 10px;
  margin-bottom: 30px;
  width: 80%;
  margin-left: 10%;
  cursor: pointer;
}
.headTitle {
  display: inline-block;
  margin-left: 10px;
  height: 40px;
  font-size: 13px;
}
.portrait {
  height: 50px;
  width: 200px;
  background: #28a0f7;
  position: absolute;
  bottom: 0;
}
.portrait img {
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
.phone {
  margin-left: 10px;
  color: white;
  margin-right: 20px;
  /* width:125px; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.br {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}
.exit img {
  height: 12px;
  width: 12px;
  margin-top: 4px;
}
.exit {
  line-height: 20px;
  cursor: pointer;
}
.exit2 {
  line-height: 20px;
}
.exit:not(:last-child):hover {
  color: #40a5ed;
}

.el-popover {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/common/leftNav.vue